import { FormBlockDescription, TitledFormBlock } from './components';

export default {
  FormBlockDescription,
  TitledFormBlock
};